import { Record } from 'immutable';
import { SET_GRID_INSTANCE, SET_GRID_ID_NAME } from './actions';

const State = Record({
  gridInstance: null,
  gridStateName: null
});

export default (state = new State(), action) => {
  switch (action.type) {
    case SET_GRID_INSTANCE:
      return state.set('gridInstance', action.gridInstance);

    case SET_GRID_ID_NAME:
      return state.set('gridStateName', action.gridStateName);

    default:
      return state;
  }
};
